import { Dispatch } from '@reduxjs/toolkit';
import { getSelectedApplication } from 'src/commons/apis';
import { updateSelectedApplication } from 'src/features/nav/store/slice';

export const fetchSelectedApplication =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    const selectedApplication = await getSelectedApplication();
    dispatch(updateSelectedApplication({ selectedApplication }));
  };
